import React, {FC} from 'react';
import {
    ManagedUserWrapper,
    SelectableUserList,
    SelectedUser,
} from '@touchnet/user-management';

import UserDetailsModal from './user-details-modal';


export const UserMgmtUsersPage: FC = () => {
    const label = 'Edit User Roles';

    return (
        <div className="h-100 overflow-auto">
            <h3 className="pull-up">Users</h3>
            <ManagedUserWrapper actions={[]}>
                <SelectableUserList selectUserLabel={label} />
                <SelectedUser>
                    <UserDetailsModal />
                </SelectedUser>
            </ManagedUserWrapper>
        </div>
    );
};

export default UserMgmtUsersPage;
